import { createSelector } from 'reselect';
import _ from 'lodash';

const getJourneysObject = (state) => state.driverJourneys.journeys;
const getJourneysData = (state) => state.driverJourneys.plainData;
const getIsDriverJourneysLoading = (state) => state.driverJourneys.loading;

const _getJourneySelectorProps = (_, journeyId, fields) => ({
  journeyId,
  fields,
});

const _getStopSelectorProps = (_, journeyId, stopId, fields) => ({
  journeyId,
  stopId,
  fields,
});

const getJourneyFields = createSelector(
  getJourneysData,
  _getJourneySelectorProps,
  (journeys, { journeyId, fields }) => {
    return _.pick(journeys.get(journeyId), fields);
  }
);

const getJourneyStopFields = createSelector(
  getJourneysData,
  _getStopSelectorProps,
  (journeys, { journeyId, stopId, fields }) => {
    return _.pick(journeys.get(journeyId).stops[stopId], fields);
  }
);

export { getJourneyFields, getJourneysObject, getJourneyStopFields, getIsDriverJourneysLoading };
